import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { RESPONSIVE_MEDIA_QUERY_PHONE, RESPONSIVE_MEDIA_QUERY_TABLET, RESPONSIVE_MEDIA_QUERY_DESKTOP } from '../../../responsive';
import { Observer } from '../../patterns/Observer';
let instance;
export class DeviceTypeMediaQuery {
  constructor() {
    _defineProperty(this, "observer", void 0);
    _defineProperty(this, "lists", {});
    _defineProperty(this, "deviceType", null);
    _defineProperty(this, "subscribe", listener => this.observer.on(listener));
    this.observer = new Observer();
    this.initDeviceType('phone', RESPONSIVE_MEDIA_QUERY_PHONE);
    this.initDeviceType('tablet', RESPONSIVE_MEDIA_QUERY_TABLET);
    this.initDeviceType('desktop', RESPONSIVE_MEDIA_QUERY_DESKTOP);
  }
  static ensureSingleton() {
    if (!instance) {
      instance = new DeviceTypeMediaQuery();
    }
    return instance;
  }
  getDeviceType() {
    return this.deviceType;
  }
  setDeviceType(deviceType) {
    this.deviceType = deviceType;
    this.observer.emit(deviceType);
  }
  initDeviceType(deviceType, query) {
    if (typeof window === 'undefined') {
      return;
    }
    const mql = window.matchMedia(query);
    mql.addListener(_ref => {
      let {
        matches
      } = _ref;
      if (matches) {
        this.setDeviceType(deviceType);
      }
    });
    if (mql.matches) {
      this.deviceType = deviceType;
    }
    this.lists[deviceType] = mql;
  }
}